import { gql, useMutation } from '@apollo/client'

import agentClient from '@/lib/apollo/client/agent'
import type { WrappedMutation } from '@/lib/apollo/types'

const removeIncomeMutation = gql`
  mutation removeIncome(
    $token: String!
    $customerId: String!
    $subjectId: String!
    $incomeId: String!
    $userId: String!
    $reason: String!
  ) {
    removeIncome(
      token: $token
      customerId: $customerId
      subjectId: $subjectId
      incomeId: $incomeId
      userId: $userId
      reason: $reason
    )
  }
`

export type MutationVars = {
  token: string
  customerId: string
  subjectId: string
  incomeId: string
  userId: string
  reason: string
}

export type RemoveIncomeData = {
  removeIncome: string | unknown
}

export const useRemoveIncomeMutation: WrappedMutation<
  RemoveIncomeData,
  MutationVars
> = () =>
  useMutation<RemoveIncomeData, MutationVars>(removeIncomeMutation, {
    client: agentClient,
  })
